<template>

<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg93"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs97"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath107"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path105" /></clipPath></defs><g
     id="g99"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g101"><g
         id="g103"
         clip-path="url(#clipPath107)"><g
           id="g109"
           transform="translate(478.874,160.2329)"><path
             d="m 0,0 v -122.733 c 0,-16.568 -13.432,-30 -30,-30 h -385.748 c -16.568,0 -30,13.432 -30,30 V -81"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path111" /></g><g
           id="g113"
           transform="translate(367.2603,37.5)"><path
             d="m 0,0 h -304.084 c -16.596,0 -30.05,13.454 -30.05,30.05 v 372.626 c 0,16.596 13.454,30.05 30.05,30.05 H 81.563 c 16.597,0 30.051,-13.454 30.051,-30.05 V 111.614 c 0,-7.97 -3.166,-15.614 -8.802,-21.249 L 21.249,8.802 C 15.613,3.166 7.97,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path115" /></g><g
           id="g117"
           transform="translate(354.9458,37.5)"><path
             d="m 0,0 c 13.598,0 24.622,11.023 24.622,24.622 v 50.063 c 0,13.598 11.023,24.622 24.621,24.622 h 50.064 c 13.598,0 24.621,11.023 24.621,24.621"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path119" /></g><g
           id="g121"
           transform="translate(121.7998,363.0464)"><path
             d="M 0,0 H -88.674"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path123" /></g><g
           id="g125"
           transform="translate(478.874,363.0464)"><path
             d="M 0,0 H -327.074"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path127" /></g><g
           id="g129"
           transform="translate(118.0498,425.3672)"><path
             d="m 0,0 c -8.454,0 -15.307,6.853 -15.307,15.307 v 48.519 c 0,8.454 6.853,15.307 15.307,15.307 h 3.443 c 8.454,0 15.307,-6.853 15.307,-15.307 V 44.859"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path131" /></g><g
           id="g133"
           transform="translate(390.5068,425.3672)"><path
             d="m 0,0 c -8.454,0 -15.307,6.853 -15.307,15.307 v 48.519 c 0,8.454 6.853,15.307 15.307,15.307 h 3.443 c 8.454,0 15.307,-6.853 15.307,-15.307 V 44.859"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path135" /></g><g
           id="g137"
           transform="translate(120.9834,268.0464)"><path
             d="m 0,0 h -35.714 c -3.945,0 -7.143,3.198 -7.143,7.143 v 35.714 c 0,3.945 3.198,7.143 7.143,7.143 H 0 c 3.945,0 7.143,-3.198 7.143,-7.143 V 7.143 C 7.143,3.198 3.945,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path139" /></g><g
           id="g141"
           transform="translate(222.8989,268.0464)"><path
             d="m 0,0 h -35.714 c -3.945,0 -7.143,3.198 -7.143,7.143 v 35.714 c 0,3.945 3.198,7.143 7.143,7.143 H 0 c 3.945,0 7.143,-3.198 7.143,-7.143 V 7.143 C 7.143,3.198 3.945,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path143" /></g><g
           id="g145"
           transform="translate(324.8149,268.0464)"><path
             d="m 0,0 h -35.714 c -3.945,0 -7.143,3.198 -7.143,7.143 v 35.714 c 0,3.945 3.198,7.143 7.143,7.143 H 0 c 3.945,0 7.143,-3.198 7.143,-7.143 V 7.143 C 7.143,3.198 3.945,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path147" /></g><g
           id="g149"
           transform="translate(426.731,268.0464)"><path
             d="m 0,0 h -35.714 c -3.945,0 -7.143,3.198 -7.143,7.143 v 35.714 c 0,3.945 3.198,7.143 7.143,7.143 H 0 c 3.945,0 7.143,-3.198 7.143,-7.143 V 7.143 C 7.143,3.198 3.945,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path151" /></g><g
           id="g153"
           transform="translate(120.9834,175.2729)"><path
             d="m 0,0 h -35.714 c -3.945,0 -7.143,3.198 -7.143,7.143 v 35.714 c 0,3.945 3.198,7.143 7.143,7.143 H 0 c 3.945,0 7.143,-3.198 7.143,-7.143 V 7.143 C 7.143,3.198 3.945,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path155" /></g><g
           id="g157"
           transform="translate(222.8989,175.2729)"><path
             d="m 0,0 h -35.714 c -3.945,0 -7.143,3.198 -7.143,7.143 v 35.714 c 0,3.945 3.198,7.143 7.143,7.143 H 0 c 3.945,0 7.143,-3.198 7.143,-7.143 V 7.143 C 7.143,3.198 3.945,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path159" /></g><g
           id="g161"
           transform="translate(324.8149,175.2729)"><path
             d="m 0,0 h -35.714 c -3.945,0 -7.143,3.198 -7.143,7.143 v 35.714 c 0,3.945 3.198,7.143 7.143,7.143 H 0 c 3.945,0 7.143,-3.198 7.143,-7.143 V 7.143 C 7.143,3.198 3.945,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path163" /></g><g
           id="g165"
           transform="translate(426.731,173.0464)"><path
             d="m 0,0 h -35.714 c -3.945,0 -7.143,3.198 -7.143,7.143 v 35.714 c 0,3.945 3.198,7.143 7.143,7.143 H 0 c 3.945,0 7.143,-3.198 7.143,-7.143 V 7.143 C 7.143,3.198 3.945,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path167" /></g><g
           id="g169"
           transform="translate(120.9834,82.5)"><path
             d="m 0,0 h -35.714 c -3.945,0 -7.143,3.198 -7.143,7.143 v 35.714 c 0,3.945 3.198,7.143 7.143,7.143 H 0 c 3.945,0 7.143,-3.198 7.143,-7.143 V 7.143 C 7.143,3.198 3.945,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path171" /></g><g
           id="g173"
           transform="translate(222.8989,82.5)"><path
             d="m 0,0 h -35.714 c -3.945,0 -7.143,3.198 -7.143,7.143 v 35.714 c 0,3.945 3.198,7.143 7.143,7.143 H 0 c 3.945,0 7.143,-3.198 7.143,-7.143 V 7.143 C 7.143,3.198 3.945,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path175" /></g><g
           id="g177"
           transform="translate(281.958,115.0576)"><path
             d="m 0,0 v 10.299 c 0,3.946 3.198,7.143 7.143,7.143 h 35.714 c 3.945,0 7.143,-3.197 7.143,-7.143 v -35.714 c 0,-3.945 -3.198,-7.143 -7.143,-7.143 H 7.143 C 3.198,-32.558 0,-29.36 0,-25.415"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path179" /></g></g></g></g></svg>
</template>
